<script setup>
import { defineAsyncComponent } from 'vue'

const props = defineProps(['icon'])
const Icon = defineAsyncComponent(() =>
  import('@/images/icons/' + props.icon[1] + '.svg')
)
</script>

<template>
  <Icon />
</template>
